<template>
  <div class="landing-page">
    <div>
      <h1 class="title">Welcome, {{ user.name }}</h1>
      <p>
        <strong>Your OHI ID:</strong> {{ user.arvcAccountId }}
        <span v-if="user.arvcAccountId" style="margin-left: 10px; margin-right: 10px;">|</span>
        <router-link v-if="user.aCID" :to="`/membership-card/${user.aCID}`">
          <b-icon-card-text /> Discount Card
        </router-link>
      </p>
      <p>
        Welcome to your personalized member portal. This is your one-stop shop for everything OHI.
        View or edit your business info, update your GoCampingAmerica listing, pay invoices,
        access your music license certificates, and more. Need assistance? Get in touch through
        the contact us page or ring us at 303-681-0401.
      </p>
      <PortalSection />
      <AnnouncementItem />
      <LinkCard />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import PortalSection from '../components/PortalSection.vue';
import AnnouncementItem from '../components/AnnouncementItem.vue';
import LinkCard from '../components/LinkCard.vue';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Landing',
  components: {
    PortalSection,
    AnnouncementItem,
    LinkCard,
  },
  data() {
    return {
      user: {
        arvcAccountId: '', // Initialize the ARVC_Account_ID_New__c field
      },
      showModal: false,
    };
  },
  async mounted() {
    await this.fetchContactInfo();
    await this.fetchAccountInfo();
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async fetchContactInfo() {
      try {
        const rawContact = await axios.get(`${server}/api/contact`);
        if (rawContact.data.redirect) {
          localStorage.setItem('postLogin', window.location.href);
          window.location.href = `${rawContact.data.redirect}?r=${window.location.href}`;
        } else if (rawContact.data) {
          const myContact = rawContact.data;
          this.user = {
            ...this.user, // Spread existing user data
            contactId: myContact.Id,
            email: myContact.Email,
            membership: myContact.FS_Membership_Type1__c,
            name: `${myContact.FirstName} ${myContact.LastName}`,
            badges: myContact.OrderApi__Badges__c,
            arvcId: myContact.ARVC_Contact_ID__c,
          };
          localStorage.setItem('arvcportal_user', JSON.stringify(this.user));
        }
      } catch (err) {
        console.log({ contactError: err });
      }
    },
    async fetchAccountInfo() {
      try {
        const response = await axios.get(`${server}/api/accounts`);
        // Check for a redirect in the account information response
        if (response.data.redirect) {
          // Store the current location for returning after login
          localStorage.setItem('postLogin', window.location.href);
          // Redirect the user as indicated by the API response
          window.location.href = `${response.data.redirect}?r=${window.location.href}`;
          return;
        }
        // Assuming the first object in the response is the correct account
        // and accessing the ARVC_Account_ID_New__c field within the Account object
        const accountInfo = response.data[0]; // Adjust based on actual response structure
        if (accountInfo && accountInfo.Account && accountInfo.Account.ARVC_Account_ID_New__c) {
          this.user.arvcAccountId = accountInfo.Account.ARVC_Account_ID_New__c;
          this.user.aCID = accountInfo.Account.Id;
        }
      } catch (err) {
        console.log({ accountError: err });
      }
    },
  },
};
</script>

<style lang="scss"></style>
